export const preprocessText = (text: string): string => {
  // Regular expression to match the unwanted pattern openAI returns and remove it
  return text.replace(/【.*?†source】/g, '')
}

export const formatEmptyLabel = (
  count: number,
  q: string,
  categoryFilter: string,
  categoriesById: Record<string, { id: string; name: string }>,
): string => {
  if (count > 0) return ''
  const parts: string[] = []
  if (q) parts.push(`za „${q}”`)

  if (categoryFilter !== 'all') {
    const catName = categoriesById[categoryFilter]?.name ?? 'izabranoj kategoriji'
    parts.push(`u „${catName}”`)
  }

  return parts.length ? `Nema rezultata ${parts.join(' ')}.` : 'Još nema unetih pitanja.'
}
